export default "__VITE_ASSET__BkdS$tV8__"